import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer className="footer" >
            <span>R2S Version v1.2.0 (PPDI GC and PCC Combined us-west-2) </span>
        </footer>
    )
}

export default Footer